module.exports = __webpack_public_path__ + "static/img/wlys.32964d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wlys.png
// module id = XYPF
// module chunks = 4